import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`軟體架構師/研發團隊管理者。曾獲選四屆微軟最有價值專家(MVP)，擅長帶領團隊，進行軟韌硬整合的專案/產品/平台開發，提供 Cloud Service、Mobile APP、Web AP、Desktop AP、IoT Device 等面向組合的解決方案。在團隊裡負責核心基礎架構的導入與撰寫、人員的培訓與指導、並解決團隊遇到的技術難題。`}</p>
    <p>{`部落格: `}<a parentName="p" {...{
        "href": "https://dotblogs.com.tw/clark"
      }}>{`https://dotblogs.com.tw/clark`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      